/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LocationUsageRow } from './LocationUsageRow';
import {
    LocationUsageRowFromJSON,
    LocationUsageRowFromJSONTyped,
    LocationUsageRowToJSON,
    LocationUsageRowToJSONTyped,
} from './LocationUsageRow';

/**
 * 
 * @export
 * @interface LocationUsageWidgetData
 */
export interface LocationUsageWidgetData {
    /**
     * 
     * @type {Array<LocationUsageRow>}
     * @memberof LocationUsageWidgetData
     */
    items: Array<LocationUsageRow>;
}

/**
 * Check if a given object implements the LocationUsageWidgetData interface.
 */
export function instanceOfLocationUsageWidgetData(value: object): value is LocationUsageWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function LocationUsageWidgetDataFromJSON(json: any): LocationUsageWidgetData {
    return LocationUsageWidgetDataFromJSONTyped(json, false);
}

export function LocationUsageWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocationUsageWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(LocationUsageRowFromJSON)),
    };
}

export function LocationUsageWidgetDataToJSON(json: any): LocationUsageWidgetData {
    return LocationUsageWidgetDataToJSONTyped(json, false);
}

export function LocationUsageWidgetDataToJSONTyped(value?: LocationUsageWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(LocationUsageRowToJSON)),
    };
}

